import React from "react";
import { Star } from "lucide-react";
import { GoogleIcon } from "@/components/site/GoogleRatingBadge";
import { stats } from "@/lib/site-data";

export const COUNTER_DURATION_MS = 1800;

export const formatPolishInteger = (value: number) =>
  String(value).replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");

const counterValues = [
  { value: 5789, width: "6ch", label: "5 789 przeprowadzonych upadłości" },
  {
    value: 61,
    width: "2ch",
    suffix: " mln zł",
    label: "61 mln zł - największy umorzony dług jednego Klienta",
  },
  {
    value: 26,
    width: "2ch",
    suffix: " lat",
    label: "26 lat doświadczenia naszego zespołu",
  },
];

export function StatsCounters({
  limit,
  includeGoogleRating = false,
}: {
  limit?: number;
  includeGoogleRating?: boolean;
}) {
  return (
    <div
      className="stats-grid evidence-stats"
      data-counter-duration={COUNTER_DURATION_MS}
    >
      {stats.slice(0, limit).map((stat, index) => {
        const counter = counterValues[index];
        return (
          <article className="stat-card" key={stat.label}>
            <strong
              className="stat-counter"
              aria-label={counter?.label ?? stat.label}
            >
              {counter ? (
                <>
                  <span
                    className="stat-counter-number"
                    style={{ minWidth: counter.width }}
                  >
                    {formatPolishInteger(counter.value)}
                  </span>
                  {counter.suffix && (
                    <span className="stat-counter-suffix">
                      {counter.suffix}
                    </span>
                  )}
                </>
              ) : (
                stat.value
              )}
            </strong>
            <h3>{stat.label}</h3>
            <p>{stat.note}</p>
          </article>
        );
      })}
      {includeGoogleRating && (
        <article
          className="stat-card local-google-stat-card"
          aria-label="Ocena 5,0 w Google na podstawie 249 opinii Klientów"
        >
          <div className="local-google-stat-brand">
            <GoogleIcon />
            <span>Google</span>
          </div>
          <strong>
            <span>5,0</span>
          </strong>
          <span className="local-google-stat-stars" aria-hidden="true">
            <Star size={17} fill="currentColor" />
            <Star size={17} fill="currentColor" />
            <Star size={17} fill="currentColor" />
            <Star size={17} fill="currentColor" />
            <Star size={17} fill="currentColor" />
          </span>
          <h3>249 opinii z Google</h3>
          <p>Wizytówki naszych kancelarii.</p>
        </article>
      )}
    </div>
  );
}
